import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mod_wrap" }
const _hoisted_4 = { class: "mod_c" }
const _hoisted_5 = {
  key: 0,
  class: "mod_c_title"
}
const _hoisted_6 = { class: "mod_c_tbody select_none" }

import { useRoute } from 'vue-router';
import Crumb from '@/components/Crumb.vue';

const __default__ = { name: '' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(route).meta?.customMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(Crumb),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_unref(route).meta.hidden)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(route).meta?.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_view)
              ])
            ])
          ])
        ])
      ]))
}
}

})